module.exports = __webpack_public_path__ + "img/er.f0e6f6df.png";